module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VueCarousel-slide",
    class: {
      'VueCarousel-slide-active': _vm.isActive,
      'VueCarousel-slide-center': _vm.isCenter,
      'VueCarousel-slide-adjustableHeight': _vm.isAdjustableHeight
    },
    attrs: {
      "tabindex": "-1",
      "aria-hidden": !_vm.isActive,
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90423848!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/vue-carousel/Slide.vue
// module id = 2102
// module chunks = 2